module.exports = __webpack_public_path__ + "img/p2-22.b2d74970.png";